import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

/**
 * Company read-only condition specifically for bank accounts page
 */
export const useReadOnlyCompany = () => {
    const company = useCompanyBasedOnUrl();

    return company.isReadonly || !company.flags.hasActiveIntegration;
};
